import { render, staticRenderFns } from "./CardCertificate.vue?vue&type=template&id=7a535142&scoped=true"
import script from "./CardCertificate.vue?vue&type=script&lang=js"
export * from "./CardCertificate.vue?vue&type=script&lang=js"
import style0 from "./CardCertificate.vue?vue&type=style&index=0&id=7a535142&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a535142",
  null
  
)

export default component.exports